import { createAction } from 'redux-actions';
import { Location, Action as HistoryAction } from 'history';
import { actionKey } from './constants';
import { DuperbrowseHistoryState } from '../../Duperbrowse/redux/types';

// for internal use - this has all duperbrowse-handled locations
export const duperbrowseHistoryChanged = createAction(
  `${actionKey}.HISTORY_CHANGED.DUPERBROWSE`,
  (location: Location<DuperbrowseHistoryState>, action: HistoryAction) => ({
    location,
    action,
  })
);

// for general use - this has all unhandled history updates
// (ie. anything not handled by duperbrowse)
export const historyChanged = createAction(
  `${actionKey}.HISTORY_CHANGED`,
  (location: Location<any>, action: HistoryAction) => ({
    location,
    action,
  })
);

// Ad damz is half duperbrowse, we need to handle it differently
export const historyChangedDamz = createAction(
  `${actionKey}.HISTORY_CHANGED.DAMZ`,
  (location: Location<any>, action: HistoryAction) => ({
    location,
    action,
  })
);
